<template>
    <div id="Section-06" class="section-06 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs"
                 :style="{backgroundImage: `url(${s06Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="cb-bg-blue block-header wsl-p-y-10">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">06</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Страхование</div>
                    </div>
                </div>

                <div class="wsl-show-sm wsl-show-xs wsl-p-a-15" style="
                    background-color: #fff;">
                    <div class="wsl-flex-middle-ng">
                        <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Страхование для ваших туристов - </span>
                                <span class="Oswald-Light cb-blue t36">в три клика</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-30 padding-sm-xs">
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Страхование выезжающих за рубеж и страхование от невыезда
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Надежная страховая компания с высшим рейтингом надежности
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Максимально простой интерфейс и прозрачные условия без франшизы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Высокая комиссия и постоплата выписанных полисов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Полисы соответствуют требованиям консульств для подачи документов на визы
                    </div>
                    <div class="wsl-m-t-60 wsl-m-b-50 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-relative wsl-show-md wsl-p-b-30"
                 :style="{backgroundImage: `url(${s06Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    top: 0; right: 0; width: 33.34%; height: 5%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s06Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top left;
                    top: 0; left: 0; width: 25.06%; height: 12.3%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 36%; left: 21.93%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">06
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-10">Страхование</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 12.6%;">
                </div>

                <div class="" style="padding-left: 18%; padding-right: 10%; padding-top: 120px;">
                    <div class="wsl-m-b-30" style="line-height: 1.2">
                        <span class="Oswald-Light cb-cyan t48">Страхование для ваших туристов -</span><br>
                        <span class="Oswald-Light cb-blue t48">в три клика</span>
                    </div>

                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Страхование выезжающих за рубеж и страхование от невыезда
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Надежная страховая компания с высшим рейтингом надежности
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Максимально простой интерфейс и прозрачные условия без франшизы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Высокая комиссия и постоплата выписанных полисов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Полисы соответствуют требованиям консульств для подачи документов на визы
                    </div>
                    <div class="wsl-m-t-60 wsl-m-b-50">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-w-100 wsl-h-100 wsl-relative wsl-hide-md wsl-hide-sm wsl-hide-xs">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/s06-bg1.jpg">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    top: 0; right: 0; width: 33.34%; height: 5%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s06Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top left;
                    top: 0; left: 0; width: 25.06%; height: 12.3%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 36%; left: 21.93%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">06
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Страхование</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 12.6%;">
                </div>

                <div class="wsl-abs" style="top: 18.4%; padding-left: 16.85%; padding-right: 15%;">
                    <div class="wsl-m-b-30" style="line-height: 1.2">
                        <span class="Oswald-Light cb-cyan t48">Страхование для ваших туристов -</span><br>
                        <span class="Oswald-Light cb-blue t48">в три клика</span>
                    </div>

                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Страхование выезжающих за рубеж и страхование от невыезда
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Надежная страховая компания с высшим рейтингом надежности
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Максимально простой интерфейс и прозрачные условия без франшизы
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Высокая комиссия и постоплата выписанных полисов
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Полисы соответствуют требованиям консульств для подачи документов на визы
                    </div>
                    <div class="wsl-m-t-100 wsl-m-b-30 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-06',
  props: {
    blueBox: String,
    s06Bg1: String,
    s06Bg2: String
  }
}
</script>

<style scoped>

</style>
